import React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Card({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 19"
      fill="none"
    >
      <Path
        d="M4.92773 14.034V4.96582H6.21345V14.034H4.92773ZM6.85631 14.034V4.96582H8.14202V14.034H6.85631ZM8.78488 14.034V4.96582H9.42773V14.034H8.78488ZM10.7134 14.034V4.96582H11.9992V14.034H10.7134ZM12.642 14.034V4.96582H14.5706V14.034H12.642ZM15.2134 14.034V4.96582H15.8563V14.034H15.2134ZM17.142 14.034V4.96582H19.0706V14.034H17.142Z"
        fill={iconColor}
      />
      <Rect
        x="2.33984"
        y="2.35205"
        width="19.3214"
        height="14.2955"
        rx="1.375"
        stroke="black"
        stroke-width="1.25"
        stroke-linejoin="round"
      />
    </Svg>
  );
}
